import { render, staticRenderFns } from "./userfile.vue?vue&type=template&id=4ecd0cb1&"
import script from "./userfile.vue?vue&type=script&lang=js&"
export * from "./userfile.vue?vue&type=script&lang=js&"
import style0 from "./userfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports